const config = {
  403: {
    img: 'https://gw.alipayobjects.com/zos/rmsportal/byTGXmzwJVwgotvxHQsU.svg',
    title: '403',
    desc: '对不起，你没有权限',
  },
  404: {
    img: 'https://gw.alipayobjects.com/zos/rmsportal/GdXXOjtMMzaPfCziUVYt.svg',
    title: '404',
    desc: '你要找的页面不存在',
  },
  500: {
    img: 'https://gw.alipayobjects.com/zos/rmsportal/OpTUNDbQGfEWLubSrJap.svg',
    title: '500',
    desc: '服务器错误，我们正在维修',
  },
};

export default config;



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Exception/typeConfig.js